"use client";
import { useRouter, useSearchParams } from "next/navigation";
import { FunctionComponent, useEffect } from "react";
import { giveSourcepointConsent } from "./utils";

declare global {
	interface Window {
		_sp_queue?: (() => void)[];
	}
}

export const SourcepointUrlConsent: FunctionComponent = () => {
	const consent = useSearchParams()?.get("consent");
	const router = useRouter();

	useEffect(() => {
		if (!consent) {
			return;
		}

		const onSourcepointReady = () => {
			const doConsent = consent === "true";
			giveSourcepointConsent(doConsent);

			const currentUrl = new URL(window.location.href);
			currentUrl.searchParams.delete("consent");
			router.replace(currentUrl.pathname + currentUrl.search);
		};

		if (window._sp_ && "addEventListener" in window._sp_) {
			window._sp_.addEventListener("onMessageReady", onSourcepointReady);

			return () => window._sp_?.removeEventListener("onMessageReady", onSourcepointReady);
		}

		window._sp_queue = [];
		window._sp_queue.push(onSourcepointReady);
	}, [consent, router]);

	return null;
};
